import { DesignTokens } from "../../types"
import { colors } from "../foundation"

export const createBorderWidths: (
  foundation: DesignTokens.Foundation,
) => DesignTokens.BorderWidths = () => ({
  none: "0px",
  small: "1px",
  medium: "2px",
  large: "4px",
})

export const createBorderColors: (
  foundation: DesignTokens.Foundation,
) => DesignTokens.BorderColors = ({ colors }) => ({
  inverse: colors.white,
  divider: colors.gray100,
  default: colors.gray200,
  disabled: colors.gray200,
  radio: colors.gray400,
  hover: colors.black,
  strong: colors.black,
  brand: colors.green400,
  urgent: colors.red600,
  error: colors.red600,
  selectionQuiet: colors.blue200,
  selection: colors.blue400,
  selectionHover: colors.blue600,
  action: colors.blue400,
  actionHover: colors.blue600,
  transparent: colors.transparent,
})

export const createBorderRadii: (
  foundation: DesignTokens.Foundation,
) => DesignTokens.BorderRadii = () => ({
  none: "0",
  small: "4px",
  medium: "6px",
  round: "50%",
  full: "9999px",
})
